const angular = require('angular');

const { smallFormatMenuComponentDefinition } = require('./small-format-menu.component');
const { smallFormatMenuPanelComponentDefinition } = require('./small-format-menu-panel.component');

angular.module('wowApp.common')
    .component('wowSmallMenu', smallFormatMenuComponentDefinition)
    .component('wowSmallMenuPanel', smallFormatMenuPanelComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/smallformatmenu/index.js